export const DEFAULT_BUSINESS_CASE_OFFER_NOT_SENT_MINIMUM_DAYS = 1;
